import { BaseNodeCommand, NodeChangeRecord } from '../../../core/commands/base/BaseNodeCommand';

export class ChangeNodeTextCommand extends BaseNodeCommand {
  private nodeIds: string[];
  private field: string;
  private newValue: string | undefined;
  
  constructor(nodeIds: string[], field: string, newValue: string | undefined) {
    const fieldDisplay = field === 'name' ? 'name' : field;
    const description = newValue 
      ? `Change ${fieldDisplay} to "${newValue}"`
      : `Clear ${fieldDisplay}`;
    super('Change Text', description);
    this.nodeIds = nodeIds;
    this.field = field;
    this.newValue = newValue;
  }
  
  protected doExecute(): NodeChangeRecord[] {
    // Prepare batch updates
    const batchUpdates = this.nodeIds.map(nodeId => {
      const changes: any = {};
      
      if (this.field === 'name') {
        changes.name = this.newValue;
      } else if (this.field === 'birthDate' || this.field === 'deathDate') {
        changes.props = changes.props || {};
        changes.props[this.field] = this.newValue;
      }
      
      return { nodeId, changes };
    });
    
    // Apply all updates in a single batch transaction
    if (batchUpdates.length > 1) {
      const batchRecords = (this.getMutationManager() as any).applyBatchNodeChanges(batchUpdates);
      return batchRecords || [];
    } else if (batchUpdates.length === 1) {
      const record = this.getMutationManager().applyNodeChange(batchUpdates[0].nodeId, batchUpdates[0].changes);
      return record ? [record] : [];
    }
    
    return [];
  }
}